import { sm2 } from 'sm-crypto';

// 公钥
const PUBLIC_KEY =
  '041b665acca408d4e827a86ad68de8cde4a1e9a36d2c58a1d85e51c2621a211c29cc64f6fe12781e2836b7a9776fdb46f9b337a6b3f46fc1aed8c1f2193a6f8376';
const PRIVATE_KEY = '5126db8bb60e851428ebb6223eca75504949a5bcc5bb4b929689e0ba46875414';

// 可配置参数
// 1 - C1C3C2；	0 - C1C2C3；  默认为1
const cipherMode = 1;

//加密
export function doSM2Encrypt(str) {
  let msg = str;
  if (typeof str !== 'string') {
    msg = JSON.stringify(str);
  }
  // //console.log(msg,'加密前')
  const publicKey = PUBLIC_KEY;
  // 加密结果
  const encryptData = sm2.doEncrypt(msg, publicKey, cipherMode);
  //Base64编码 自行选择是否使用
  //let baseEncode = Base64.encode(encryptData)
  // 加密后的密文前需要添加04，后端才能正常解密 (不添加04，后端处理也可以)
  const encrypt = '04' + encryptData;
  return encrypt;
}

// 解密
export function doSM2DecryptStr(enStr) {
  let msg = enStr;
  if (typeof enStr !== 'string') {
    msg = JSON.stringify(enStr);
  }
  const privateKey = PRIVATE_KEY;
  const enval = enStr.substring(2);
  // 解密结果
  const doDecrypt = sm2.doDecrypt(enval, privateKey, cipherMode);
  // //console.log("doDecrypt=>", doDecrypt)
  // 解密后类型转换
  return doDecrypt;
}
